export default "__VITE_ASSET__B6beL_ZG__"